import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function PieChart({ noIssues, foundIssues }) {
  const data = {
    labels: ['No Issues', 'Found Issues'],
    datasets: [
      {
        data: [noIssues, foundIssues],
        backgroundColor: ['#2c59a2', '#dd052e'],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div
    >

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >

        <div style={{ width: '100%', height: '325px' }}>
          <Pie data={data} options={options} />
        </div>
      </div>
    </div>
  );
}


export default PieChart;
